var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { DesignerCommandHandler } from './tools/designerCommandHandler';
import { RotateMultipleTool } from './tools/rotateMultipleTool';
import { ResizeMultipleTool } from './tools/resizeMultipleTool';
import { GuidedDraggingTool } from './tools/guidedDraggingTool';
import { SnapLinkReshapingTool } from './tools/snapLinkReshapingTool';
import { ExtendedSectorReshapingTool } from './tools/extended-sector-reshaping-tool';
import * as _ from 'lodash';
import { ViewBackgroundFillType } from '../../view-data/view/background/view-background-fill-type';
import { GraphUtils } from '../../view-data/shared/graph/graph-utils';
import { ZoomHelper } from '../designer/shared/zoom-helper';
import { ZoomOperation } from '../designer/shared/zoom-operation';
import { RingGraphReshapingTool } from './tools/ring-reshaping-tool';
import { EmptyDiagramModel } from './empty-diagram-model';
import { GeometryReshapingTool } from './tools/geometry-reshaping-tool';
import { DiagramConsts } from './diagram-consts';
import { ConfigureViewType } from '../designer/shared/configure-view-type';
import { RowResizingTool } from './tools/RowResizingTool';
import { ColumnResizingTool } from './tools/ColumnResizingTool';
import * as go from '../../../libs/gojs/release/go';
import { ConfigureConsts } from '../../../shared/configure-consts';
import { ImageUrlHelper } from './utils/imageUrlHelper';
var $ = go.GraphObject.make;
var backgroundLayerName = 'bg';
var DiagramEx = /** @class */ (function (_super) {
    __extends(DiagramEx, _super);
    function DiagramEx(containerId, width, height, model, templateService, layerService, configureViewType, popViewDoesNotSupportVideoTip) {
        if (configureViewType === void 0) { configureViewType = ConfigureViewType.Web; }
        if (popViewDoesNotSupportVideoTip === void 0) { popViewDoesNotSupportVideoTip = ''; }
        var _this = _super.call(this, containerId) || this;
        _this.containerId = containerId;
        _this.width = width;
        _this.height = height;
        _this.templateService = templateService;
        _this.layerService = layerService;
        _this.configureViewType = configureViewType;
        _this.popViewDoesNotSupportVideoTip = popViewDoesNotSupportVideoTip;
        _this._isShowGrid = false;
        _this._isGridSnapEnabled = false;
        _this._isGuidelineSnapEnabled = false;
        _this.init(model);
        return _this;
    }
    Object.defineProperty(DiagramEx.prototype, "isShowGrid", {
        get: function () {
            return this._isShowGrid;
        },
        set: function (value) {
            if (this._isShowGrid !== value) {
                this.gridEx.visible = value;
                this._isShowGrid = value;
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DiagramEx.prototype, "isGridSnapEnabled", {
        get: function () {
            return this._isGridSnapEnabled;
        },
        set: function (value) {
            if (this._isGridSnapEnabled !== value) {
                this.draggingToolEx.isGridSnapEnabled = value;
                this._isGridSnapEnabled = value;
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DiagramEx.prototype, "isGuidelineSnapEnabled", {
        get: function () {
            return this._isGuidelineSnapEnabled;
        },
        set: function (value) {
            if (this._isGuidelineSnapEnabled !== value) {
                this.draggingToolEx.isGuidelineSnapEnabled = value;
                this.draggingToolEx.isGuidelineEnabled = value;
                this._isGuidelineSnapEnabled = value;
            }
        },
        enumerable: true,
        configurable: true
    });
    DiagramEx.createEmptyDiagramModel = function () {
        return new EmptyDiagramModel();
    };
    DiagramEx.getDiagramModel = function (modelJSON) {
        var diagramModel = JSON.parse(modelJSON);
        var model;
        // 之前的版本用的是go.Model，这里做兼容性处理。
        if (diagramModel.class === 'go.Model') {
            model = new go.GraphLinksModel(diagramModel.nodeDataArray);
        }
        else {
            model = go.Model.fromJson(modelJSON);
        }
        var nodeDataArray = model.nodeDataArray;
        var linkDataArray = model.linkDataArray;
        nodeDataArray.concat(linkDataArray).forEach(function (t) {
            if (!t.hasOwnProperty('zOrder')) {
                model.setDataProperty(t, 'zOrder', 0);
            }
        });
        return model;
    };
    DiagramEx.prototype.resize = function (width, height) {
        if (!(width && height)) {
            return;
        }
        this.gridEx.visible = !this.gridEx.visible;
        this.skipsUndoManager = true;
        this.fixedBounds.setSize(new go.Size(width, height));
        this.gridEx.desiredSize = new go.Size(width, height);
        this.gridEx.visible = !this.gridEx.visible;
        this.width = width;
        this.height = height;
        this.refreshBackground();
        this.skipsUndoManager = false;
    };
    DiagramEx.prototype.getViewSettings = function () {
        var settings = this.model.modelData.settings;
        if (!settings) {
            return { background: { fillType: ViewBackgroundFillType.SolidColor, solidColor: 'white' } };
        }
        else {
            return settings;
        }
    };
    DiagramEx.prototype.setViewSettings = function (v) {
        this.model.modelData.settings = v;
        this.refreshBackground();
    };
    DiagramEx.prototype.init = function (model) {
        this.fixedBounds = new go.Rect(0, 0, this.width, this.height);
        this.initialContentAlignment = go.Spot.Center;
        this.padding = 0;
        this.nodeTemplateMap = this.templateService.getNodeDiagramTemplateMap(this.containerId.replace('View-', ''));
        this.linkTemplateMap = this.templateService.getLinkDiagramTemplateMap();
        this.allowDrop = true; // accept drops from palette
        this.allowLink = true; // no user-drawn links
        this.animationManager.isInitial = false;
        this.minScale = ZoomHelper.defaultMinScale;
        this.maxScale = ZoomHelper.defaultMaxScale;
        this.initCommandHandler();
        this.initTools();
        this.initGrid();
        this.initEvents();
        this.initZoom();
        this.undoManager.isEnabled = true;
        if (model) {
            this.model = DiagramEx.getDiagramModel(model);
        }
        else {
            this.model = new go.GraphLinksModel();
        }
        // 背景依赖viewSettings,在初始化viewSettings属性后再执行。
        this.initBackground();
    };
    DiagramEx.prototype.initCommandHandler = function () {
        var commandHandler = new DesignerCommandHandler(this.layerService);
        // default to having arrow keys move selected nodes
        commandHandler.arrowKeyBehavior = 'move';
        this.commandHandler = commandHandler;
    };
    //#region tools
    DiagramEx.prototype.initTools = function () {
        var toolManager = this.toolManager;
        toolManager.rotatingTool = new RotateMultipleTool();
        toolManager.resizingTool = new ResizeMultipleTool();
        toolManager.resizingTool.isGridSnapEnabled = true;
        toolManager.linkReshapingTool = new SnapLinkReshapingTool();
        toolManager.linkReshapingTool.handleArchetype =
            $(go.Shape, 'Rectangle', { width: 10, height: 10, fill: '#fffc00', stroke: '#60768c' });
        toolManager.linkReshapingTool.midHandleArchetype =
            $(go.Shape, 'Diamond', { width: 12, height: 12, fill: '#fffc00', stroke: '#60768c' });
        toolManager.linkingTool.isUnconnectedLinkValid = true;
        toolManager.linkingTool.portGravity = 20;
        this.initDraggingTool();
        this.initDragSelectingTool();
        this.initPanningTool();
        this.initRelinkingTool();
        toolManager.mouseDownTools.add(new ExtendedSectorReshapingTool());
        toolManager.mouseDownTools.add(new RingGraphReshapingTool());
        toolManager.mouseDownTools.add(new GeometryReshapingTool());
        toolManager.mouseDownTools.add(new ColumnResizingTool());
        toolManager.mouseDownTools.add(new RowResizingTool());
    };
    DiagramEx.prototype.initRelinkingTool = function () {
        var relinkingTool = this.toolManager.relinkingTool;
        relinkingTool.isUnconnectedLinkValid = true;
        relinkingTool.portGravity = 20;
        relinkingTool.fromHandleArchetype =
            $(go.Shape, 'Rectangle', { width: 10, height: 10, fill: '#fffc00', stroke: '#60768c', segmentIndex: 0 });
        relinkingTool.toHandleArchetype =
            $(go.Shape, 'Rectangle', { width: 10, height: 10, fill: '#fffc00', stroke: '#60768c', segmentIndex: -1 });
    };
    DiagramEx.prototype.initDraggingTool = function () {
        var draggingTool = new GuidedDraggingTool();
        draggingTool.dragsTree = false; // dragging for both move and copy
        draggingTool.horizontalGuidelineColor = 'blue';
        draggingTool.verticalGuidelineColor = 'blue';
        draggingTool.centerGuidelineColor = 'green';
        draggingTool.guidelineWidth = 1;
        draggingTool.dragsLink = true;
        draggingTool.isGridSnapEnabled = this.isGridSnapEnabled;
        draggingTool.isGuidelineSnapEnabled = this._isGuidelineSnapEnabled;
        draggingTool.isGuidelineEnabled = this._isGuidelineSnapEnabled;
        this.toolManager.draggingTool = draggingTool;
        this.draggingToolEx = draggingTool;
    };
    DiagramEx.prototype.initDragSelectingTool = function () {
        var dragSelectingTool = this.toolManager.dragSelectingTool;
        dragSelectingTool.isEnabled = true;
        dragSelectingTool.delay = 0;
        dragSelectingTool.box =
            $(go.Part, { layerName: 'Tool', selectable: false }, $(go.Shape, { name: 'SHAPE', fill: null, stroke: 'chartreuse', strokeWidth: 3 }));
        dragSelectingTool.canStart = function () {
            var diagram = this.diagram;
            if (diagram === null) {
                return false;
            }
            if (diagram.firstInput.alt) {
                return false;
            }
            var e = diagram.firstInput;
            var elt = diagram.findObjectAt(e.documentPoint, null, null);
            // 锁定的元件可以在其上拖动
            if (elt !== null && elt.part !== null && elt.part.data && elt.part.data.locked === true) {
                return true;
            }
            return go.DragSelectingTool.prototype.canStart.call(dragSelectingTool);
        };
        dragSelectingTool.selectInRect = function (r) {
            var diagram = this.diagram;
            if (diagram === null) {
                return;
            }
            go.DragSelectingTool.prototype.selectInRect.call(dragSelectingTool, r);
            var sel = diagram.selection.copy();
            var lockedParts = [];
            sel.each(function (val) {
                if (val.data && val.data.locked) {
                    lockedParts.push(val);
                }
            });
            diagram.selectCollection(sel);
        };
    };
    DiagramEx.prototype.initPanningTool = function () {
        var panningTool = this.toolManager.panningTool;
        panningTool.canStart = function () {
            var diagram = this.diagram;
            if (diagram === null) {
                return false;
            }
            if (!diagram.firstInput.alt) {
                return false;
            }
            return go.PanningTool.prototype.canStart.call(panningTool);
        };
    };
    //#endregion
    DiagramEx.prototype.initEvents = function () {
        var _this = this;
        this.addDiagramListener('ExternalObjectsDropped', function () {
            // ReSharper disable once TsResolvedFromInaccessibleModule
            document.getElementById(_this.containerId).focus(); // assume keyboard focus should be on newDiagram
            _this.draggingToolEx.clearGuidelines(); // remove any guidelines
            var model = _this.model;
            var nodeDataArray = model.nodeDataArray;
            var linkDataArray = model.linkDataArray;
            var dataArray = nodeDataArray.concat(linkDataArray);
            _.forEach(dataArray, function (node) {
                if (node.zOrder == null) {
                    _this.model.setDataProperty(node, 'zOrder', _this.layerService.getMaxZOrder(dataArray) + 1);
                }
            });
        });
        this.addDiagramListener('ClipboardPasted', function () {
            var model = _this.model;
            var nodeDataArray = model.nodeDataArray;
            var linkDataArray = model.linkDataArray;
            var dataArray = nodeDataArray.concat(linkDataArray);
            var selection = _.sortBy(_this.selectCollection, function (node) { return node.zOrder; });
            _.forEach(selection, function (node) {
                _this.model.setDataProperty(node.data, 'zOrder', _this.layerService.getMaxZOrder(dataArray) + 1);
            });
        });
        this.addDiagramListener('LayoutCompleted', function (e) {
            var sel = e.diagram.selection.first();
            if (sel) {
                _this.scrollToRect(sel.actualBounds);
            }
        });
        // make grouped Parts unselectable
        this.addDiagramListener('SelectionGrouped', function (e) {
            // e.subject should be the new Group
            e.subject.memberParts.each(function (part) {
                part.selectable = false;
            });
        });
        this.addDiagramListener('SelectionUngrouped', function (e) {
            // e.parameter should be collection of ungrouped former members
            e.parameter.each(function (part) {
                part.selectable = true;
                part.isSelected = true;
            });
        });
        this.addDiagramListener('externalobjectsdropped', function (e) {
            e.subject.each(function (n) {
                if (_this.configureViewType === ConfigureViewType.PopView && n.data.category === DiagramConsts.elements.videoKey) {
                    abp.message.warn(_this.popViewDoesNotSupportVideoTip);
                    setTimeout(function () {
                        if (_this.commandHandler) {
                            _this.commandHandler.deleteSelection();
                            _this.commandHandler.diagram.focus();
                        }
                    }, 0);
                }
            });
        });
    };
    DiagramEx.prototype.initZoom = function () {
        this.scaleComputation = function (diagram, scale) {
            if (!ZoomHelper.canScale(diagram.scale, scale)) {
                return scale;
            }
            var result = scale;
            if (scale > diagram.scale) {
                result = ZoomHelper.adjustScale(scale, ZoomOperation.Increase);
            }
            else {
                result = ZoomHelper.adjustScale(scale, ZoomOperation.Decrease);
            }
            abp.event.trigger(ConfigureConsts.event.zoomChangedEventName, result);
            return result;
        };
    };
    DiagramEx.prototype.initBackground = function () {
        var gridLayer = this.findLayer('Grid');
        this.addLayerBefore($(go.Layer, { name: backgroundLayerName, isTemporary: true }), gridLayer);
        this.backgroundEx = this.getBackgroundPart();
        this.add(this.backgroundEx);
    };
    DiagramEx.prototype.getBackgroundPart = function () {
        var background = this.getViewSettings().background;
        var result = $(go.Part, 'Auto', {
            layerName: backgroundLayerName, position: new go.Point(0, 0),
            width: this.width, height: this.height, selectable: false, pickable: false
        });
        switch (background.fillType) {
            case ViewBackgroundFillType.SolidColor:
                result.add($(go.Shape, {
                    fill: background.solidColor, strokeWidth: 0,
                    width: this.width, height: this.height
                }));
                break;
            case ViewBackgroundFillType.Image:
                if (background.imageId) {
                    result.add($(go.Picture, {
                        width: this.width, height: this.height,
                        source: ImageUrlHelper.buildImageUrl(background.imageId)
                    }));
                }
                break;
            case ViewBackgroundFillType.Graph:
                result.add($(go.Picture, {
                    width: this.width, height: this.height,
                    source: GraphUtils.getCustomStyleGraphUrl(background.graphSetting)
                }));
                break;
        }
        return result;
    };
    DiagramEx.prototype.refreshBackground = function () {
        if (this.backgroundEx) {
            this.remove(this.backgroundEx);
        }
        this.backgroundEx = this.getBackgroundPart();
        this.add(this.backgroundEx);
    };
    DiagramEx.prototype.initGrid = function () {
        var gridExLayerName = 'GridEx';
        var adornmentLayer = this.findLayer('Adornment');
        this.addLayerBefore($(go.Layer, { name: gridExLayerName, isTemporary: true }), adornmentLayer);
        this.gridEx = $(go.Part, 'Grid', {
            layerName: gridExLayerName, position: new go.Point(0, 0), width: this.width, height: this.height,
            selectable: false, pickable: false, visible: this._isShowGrid
        }, $(go.Shape, 'LineH', { stroke: '#666', strokeWidth: 1, strokeDashArray: [1, 9] }));
        this.add(this.gridEx);
    };
    return DiagramEx;
}(go.Diagram));
export { DiagramEx };
